<template>
  <div class="student">
    <section class="bangzhu">
      <div class="title-box">
        <h2 class="title">我们为学生们在学习上带来什么帮助</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <div class="card">
          <img class="card-img" src="../assets/img/img-ljzy.png" alt="学习路径指引">
          <p class="card-name">学习路径指引</p>
          <p class="card-text">知心慧学悉心收集每位学生每次考试答题数据，依据学生知识点掌握情况生成学生个人知识能力模型，为每位学生规划个性化学习路径，指导学生更加有针对性地学习。</p>
        </div>
        <div class="card">
          <img class="card-img" src="../assets/img/img-ctgl.png" alt="错题管理">
          <p class="card-name">错题管理</p>
          <p class="card-text">系统自动整理学生每次考试出现的错题，节约学生自己整理错题的时间。并为每道试题匹配知识点、提供解题思路指导，便于学生订正复习，培养错题管理和回顾总结的学习意识。</p>
        </div>
        <div class="card">
          <img class="card-img" src="../assets/img/img-jzlx.png" alt="精准练习">
          <p class="card-name">精准练习</p>
          <p class="card-text">每次考后，知心慧学为学生打印个性化学习方案，准确告知各知识点的掌握情况。为每道错题匹配变式训练题，帮助学生针对知识薄弱点进行更加有针对性的练习，脱离题海，提高练习效率。</p>
        </div>
        <div class="card">
          <img class="card-img" src="../assets/img/img-msjj.png" alt="重点教师讲解">
          <p class="card-name">重点教师讲解</p>
          <p class="card-text">知心慧学在假期开展网络直播课，针对典型学习问题和重难点，聘请教师进行针对性讲解，让学生进一步掌握相关知识。</p>
        </div>

      </div>
    </section>
    <div class="separate">
      <img class="img-separate" src="../assets/img/img-separate.png" alt="">
    </div>
    <section class="txpj">
      <div class="title-box">
        <h2 class="title">看看使用知心慧学的同学怎么说</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <img class="img-zxhx" src="../assets/img/img-zxhx.png" alt="">
        <div class="card bg-card-lt">
          <div class="left">
            <img class="img-student-head" src="../assets/images/ltx.png" alt="">
          </div>
          <div class="right">
            <div class="top">
              <span class="name">李同学</span>
              <span class="school">湖北省南漳一中</span>
            </div>
            <p class="bottom">
              我的数学成绩一直处于中下水平，即使语文和英语成绩很好，但是数学一直是我成绩的薄弱项，在使用了一个学期的产品后，知心慧学帮我逐步攻克了自己数学知识点上的薄弱环节，同时给予详细的解题思路，帮助我成长！</p>

          </div>
        </div>
        <div class="card bg-card-rt">
          <div class="left">
            <img class="img-student-head" src="../assets/images/dtx.png" alt="">
          </div>
          <div class="right">
            <div class="top">
              <span class="name">代同学</span>
              <span class="school">宣威七中</span>
            </div>
            <p class="bottom">
              之前天天刷题，题目做了无数，但是数学成绩还是上不去，始终在80-90分徘徊。知心慧学最大的好处就是：让我刷题更有针对性了，哪里不会就练哪里。现在，我对数学考试的信心得到了进一步提高。</p>

          </div>
        </div>
        <div class="card bg-card-rb">
          <div class="left">
            <img class="img-student-head" src="../assets/images/ztx.png" alt="">
          </div>
          <div class="right">
            <div class="top">
              <span class="name">张同学</span>
              <span class="school">河南夏邑高级中学</span>
            </div>
            <p class="bottom">
              知心慧学错题本上面保留了我每次考试的作答原笔迹，还给每道错题配了老师指点，解析也非常详细。我会好好订正，保留好我每一个学期的错题本的，等到高三的时候再拿出来，应该会很有帮助！</p>

          </div>
        </div>
        <div class="card bg-card-lb">
          <div class="left">
            <img class="img-student-head" src="../assets/images/ctx.png" alt="">
          </div>
          <div class="right">
            <div class="top">
              <span class="name">曹同学</span>
              <span class="school">沈阳市第27中学</span>
            </div>
            <p class="bottom">
              数学一直是我的薄弱环节，过去我即使大量地做题也没有获得太大的提高，用了知心慧学之后，错题本针对自己的薄弱项进行针对性的训练给予了我事半功倍的学习方法，大大减轻了我的学习负担！</p>
          </div>
        </div>
      </div>
    </section>
    <div class="add-user">
      <p>开启您在知心慧学的全新旅程吧！</p>
      <router-link :to="{ name: 'Home', params: { status: 1 }}">
        <button class="btn-add">加入知心慧学</button>
      </router-link>
    </div>
  </div>
</template>
<script type="text/javascript">
  export default {
    data() {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>
<style scoped lang="less">

  @highlight-border: #3ECDBAFF;
  @highlight-background: #50d2c2;

  .title-box {
    .title {
      line-height: 56px;
      font-size: 40px;
      text-align: center;
      color: #333;
    }
    .border-bottom {
      display: block;
      margin: 0 auto;
      padding-top: 16px;
      width: 40px;
      border-bottom: 4px solid @highlight-border;
    }
  }

  .bangzhu {
    padding-top: 80px;
    padding-bottom: 80px;
    .content {
      padding-top: 80px;
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      justify-content: space-between;
      .card {
        width: 280px;
        height: 400px;
        padding: 40px 20px;
        box-sizing: border-box;
        &:hover {
          box-shadow: 0px 0px 20px 0px rgba(238, 238, 238, 1);
        }
        .card-img {
          display: block;
          width: 96px;
          height: 96px;
          margin: 0 auto;
        }
        .card-name {
          margin-top: 40px;
          margin-bottom: 20px;
          font-size: 24px;
          line-height: 33px;
          color: #333;
          text-align: center;

        }
        .card-text {
          font-size: 14px;
          line-height: 26px;
          text-align: center;
          color: #666;
        }
      }
    }
  }

  .separate {
    width: 1200px;
    margin: 0 auto;
    .img-separate {
      padding: 0 9px;
      /*border: 1px dashed #888;*/
    }
  }

  .txpj {
    padding-top: 80px;
    padding-bottom: 80px;
    .title-box {
      margin-bottom: 80px;
    }
    .content {
      position: relative;
      width: 1200px;
      height: 590px;
      margin: 0 auto;

      .img-zxhx {
        position: absolute;
        top: 156px;
        left: 482px;
        width: 242px;
        height: 242px;
        /*border: 1px dashed #888;*/
      }
      .card {
        width: 516px;
        height: 224px;
        padding: 28px;
        box-sizing: border-box;
        /*border: 1px dashed #888;*/
        .left {
          float: left;
          .img-student-head {
            width: 92px;
            height: 92px;
          }
        }
        .right {
          float: right;
          width: 348px;
          .top {
            color: #333;
            .name {
              font-size: 20px;
              line-height: 28px;
            }
            .school {
              margin-left: 20px;
              font-size: 16px;
              line-height: 22px;
            }
          }
          .bottom {
            margin-top: 20px;
            font-size: 14px;
            color: #666;
          }
        }
      }
      .bg-card-lt {
        position: absolute;
        top: 0;
        left: 5px;
        background: url("../assets/img/bg-card-lt.png") no-repeat center;
      }
      .bg-card-rt {
        position: absolute;
        top: 0;
        left: 685px;
        background: url("../assets/img/bg-card-rt.png") no-repeat center;
      }
      .bg-card-rb {
        position: absolute;
        top: 332px;
        left: 685px;
        background: url("../assets/img/bg-card-rb.png") no-repeat center;
      }
      .bg-card-lb {
        position: absolute;
        top: 332px;
        left: 5px;
        background: url("../assets/img/bg-card-lb.png") no-repeat center;
      }
    }
  }

  .add-user {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 80px;
    text-align: center;
    p {
      font-size: 40px;
      line-height: 56px;
      color: #333;
    }
    .btn-add {
      margin-top: 40px;
      width: 240px;
      height: 54px;
      line-height: 54px;
      font-size: 20px;
      color: #fff;
      background-color: #50D2C2;
      box-shadow: 0px 4px 16px 0px rgba(80, 210, 194, 1);
      border-radius: 27px;
      border: none;
      cursor: pointer;

    }
  }
</style>



// WEBPACK FOOTER //
// Student.vue?7fc9024b